import request from '@/utils/request'
import response from '@/utils/request'

// 大屏数据
export const dashboard = (query) => {
  return request({
    url: '/index/dashboard',
    method: 'get',
    params: query
  })
}
// 获取天气
export const selectWeather = () => {
  return response({
    url: '/index/weather',
    method: 'get',
  })
}

// 重点人员
export const keyperson = () => {
  return response({
    url: '/index/keyperson_dashboard',
    method: 'get',
  })
}
// 重点人员列表
export const keypersonList = (query) => {
  return response({
    url: '/index/keyperson_list',
    method: 'get',
    params: query
  })
}